import AutoStories from "@mui/icons-material/AutoStories";
import RecordVoiceOver from "@mui/icons-material/RecordVoiceOver";
import Chat from "@mui/icons-material/Chat";
import Healing from "@mui/icons-material/Healing";
import Work from "@mui/icons-material/Work";
import MenuBook from "@mui/icons-material/MenuBook";
import Forum from "@mui/icons-material/Forum";
import TrendingUp from "@mui/icons-material/TrendingUp";
import Rule from "@mui/icons-material/Rule";

const ICONS = {
  AutoStories,
  RecordVoiceOver,
  Chat,
  Healing,
  Work,
  MenuBook,
  Forum,
  TrendingUp,
  Rule,
};

export default function ModuleIcon({ name, ...props }) {
  const Cmp = ICONS[name] || MenuBook;
  return <Cmp {...props} />;
}
